import { HttpNetworkError } from '@inertiajs/core';

// Status-zero transport failures are recoverable navigation failures. Inertia
// must be allowed to finish its rejection path: for a prefetch, that path also
// removes the failed promise from the in-flight cache. Cancelling networkError
// leaves the promise there forever, so a later click reuses a request that can
// never settle. Suppress only the matching browser-level unhandled rejection.
export function installInertiaNetworkErrorHandler(
  router,
  { notifyOffline, addBreadcrumb },
) {
  const handledErrors = new WeakSet();
  const removeNetworkHandler = router.on('networkError', (event) => {
    if (!(event.detail.error instanceof HttpNetworkError)) return;

    handledErrors.add(event.detail.error);
    addBreadcrumb({
      category: 'network',
      message: 'Inertia navigation failed; the current page is retained',
      level: 'warning',
    });
    notifyOffline();
  });

  const preventHandledRejection = (event) => {
    if (handledErrors.has(event.reason)) event.preventDefault();
  };
  window.addEventListener('unhandledrejection', preventHandledRejection);

  return () => {
    removeNetworkHandler();
    window.removeEventListener('unhandledrejection', preventHandledRejection);
  };
}
